import React from "react";
import "./App.css";
import Main from "./containers/Main";
import PerformanceMonitor from "./components/PerformanceMonitor/PerformanceMonitor";
import FloatingParticles from "./components/FloatingParticles/FloatingParticles";
import { ThemeProvider } from "styled-components";
import { getTheme } from "./theme";
import { GlobalStyles } from "./global";

function App() {
  const theme = getTheme("blackTheme");

  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <FloatingParticles />
        <PerformanceMonitor />
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <Main theme={theme} />
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
